module.exports = __webpack_public_path__ + "static/img/3.ba452a0f.jpg";